export const PRICE_ANIMATION_SETTINGS = {

  enabled: true,

  cycleDuration: 5.2,

  oldPriceAppear: 0.45,

  oldPriceHold: 0.6,

  flipDuration: 0.45,

  easing: "cubic-bezier(0.22, 0.7, 0.2, 1)",

}